<template>
  <div class="role-manage-container">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-form :inline="true" :model="searchParams" class="search-form">
        <el-form-item label="角色名称">
          <el-input v-model="searchParams.roleName" placeholder="请输入角色名称" class="search-input"></el-input>
        </el-form-item>
        <el-form-item label="角色标识">
          <el-input v-model="searchParams.roleKey" placeholder="请输入角色标识" class="search-input"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchParams.status" placeholder="角色状态" class="search-select">
            <el-option label="全部" value=""></el-option>
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker v-model="searchParams.createTime" type="daterange" range-separator="-"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="search-btn" @click="handleSearch">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="reset-btn" @click="handleReset">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-refresh" class="refresh-btn" @click="handleRefresh">刷新列表</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 操作栏 -->
    <div class="action-bar">
      <el-button v-if="hasAddPermission" type="primary" class="add-btn" @click="addDialogVisible = true">+
        新增</el-button>
      <!-- 添加角色组件 -->
      <AddRoleDialog :visible="addDialogVisible" @update:visible="addDialogVisible = $event"
        @submit="handleAddSubmit" />
      <!-- 编辑角色组件 -->
      <EditRoleDialog :visible="editDialogVisible" @update:visible="editDialogVisible = $event" :roleId="currentRoleId"
        @submit="handleEditSubmit" />
      <!-- 权限设置组件 -->
      <PermissionDialog :visible="permissionDialogVisible" @update:visible="permissionDialogVisible = $event"
        :roleName="currentRoleName" :menuList="menuList" :roleMenus="roleMenus" @submit="handlePermissionSubmit" />
    </div>

    <!-- 表格 -->
    <div class="table-container">
      <el-table :data="roleList" style="width: 100%" v-loading="loading">
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column prop="id" label="角色编号" align="center"></el-table-column>
        <el-table-column prop="title" label="角色名称" align="center"></el-table-column>
        <el-table-column prop="slug" label="角色标识" align="center"></el-table-column>
        <el-table-column prop="sort" label="显示顺序" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <span class="status-enabled" v-if="scope.row.status === 1">启用</span>
            <span class="status-disabled" v-else>禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="" align="center"></el-table-column>
        <el-table-column label="操作" width="150" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button v-if="hasEditPermission" type="text" class="edit-btn" @click="openEditDialog(scope.row.id)">
              <i class="el-icon-edit"></i>
            </el-button>
            <el-button v-if="hasDeletePermission" type="text" class="delete-btn" @click="handleDelete(scope.row)">
              <i class="el-icon-delete"></i>
            </el-button>
            <el-button v-if="hasPermissionPermission" type="text" class="permission-btn"
              @click="openPermissionDialog(scope.row.id, scope.row.title)">
              <i class="el-icon-setting"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"
          :page-size="pagination.pageSize" :current-page="pagination.currentPage" @size-change="handleSizeChange"
          @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import AddRoleDialog from '@/components/role/AddRoleDialog.vue'
import EditRoleDialog from '@/components/role/EditRoleDialog.vue'
import PermissionDialog from '@/components/role/PermissionDialog.vue'
import { roleList, menuList, roleBindMenu, roleMenuList } from '@/api/api'
import { hasPermission } from '@/utils/auth'

export default {
  name: 'RoleManage',
  components: {
    AddRoleDialog,
    EditRoleDialog,
    PermissionDialog
  },
  data() {
    return {
      // 搜索参数
      searchParams: {
        roleName: '',
        roleKey: '',
        status: '',
        createTime: []
      },
      // 添加角色弹框可见性
      addDialogVisible: false,
      // 权限设置弹框可见性
      permissionDialogVisible: false,
      // 编辑角色弹框可见性
      editDialogVisible: false,
      // 当前角色名称
      currentRoleName: '',
      // 当前编辑角色ID
      currentRoleId: '',
      // 当前权限设置角色ID
      currentPermissionRoleId: '',
      // 角色列表
      roleList: [],
      // 菜单列表
      menuList: [],
      // 角色已有的菜单权限
      roleMenus: [],
      // 加载状态
      loading: false,
      // 分页信息
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    // 按钮权限检查
    hasAddPermission() {
      return hasPermission('add')
    },
    hasEditPermission() {
      return hasPermission('edit')
    },
    hasDeletePermission() {
      return hasPermission('delete')
    },
    hasPermissionPermission() {
      return hasPermission('setting')
    }
  },
  created() {
    // 组件创建时获取角色列表
    this.fetchRoleList();
  },
  methods: {
    // 获取角色列表
    fetchRoleList() {
      this.loading = true;
      // 映射搜索参数到API期望的字段名
      const mappedParams = {
        page: this.pagination.currentPage,
        limit: this.pagination.pageSize,
        title: this.searchParams.roleName,
        slug: this.searchParams.roleKey,
        status: this.searchParams.status,
        createTime: this.searchParams.createTime
      };
      console.log('调用roleList接口，参数:', mappedParams);
      roleList(mappedParams)
        .then(response => {
          console.log('roleList接口响应:', response);
          if (response && response.code === 200) {
            this.roleList = response.data.list || [];
            this.pagination.total = response.data.total || 0;
          } else {
            this.$message.error('获取角色列表失败');
            this.roleList = [];
            this.pagination.total = 0;
          }
        })
        .catch(error => {
          console.error('获取角色列表失败:', error);
          this.$message.error('获取角色列表异常，请重试');
          this.roleList = [];
          this.pagination.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页变化处理
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.fetchRoleList();
    },
    handleCurrentChange(current) {
      this.pagination.currentPage = current;
      this.fetchRoleList();
    },
    // 处理添加角色提交
    handleAddSubmit(formData) {
      // 这里可提交表单数据
      console.log('添加角色:', formData);
      // 添加成功后重新获取角色列表
      this.fetchRoleList();
    },
    // 打开编辑对话框
    openEditDialog(roleId) {
      this.currentRoleId = roleId;
      this.editDialogVisible = true;
    },
    // 处理编辑角色提交
    handleEditSubmit(formData) {
      // 这里可提交编辑数据
      console.log('编辑角色:', formData);
      // 编辑成功后重新获取角色列表
      this.fetchRoleList();
    },
    // 打开权限设置弹框
    openPermissionDialog(roleId, roleName) {
      this.currentPermissionRoleId = roleId;
      this.currentRoleName = roleName;
      console.log('打开权限设置弹框，角色ID:', roleId, '角色名称:', roleName);
      // 调用menuList接口获取菜单列表
      this.loading = true;
      menuList({})
        .then(response => {
          console.log('menuList接口响应:', response);
          if (response && response.code === 200) {
            // 转换菜单数据格式
            this.menuList = this.transformMenuList(response.data.list || []);

            // 调用roleMenuList接口获取角色已有的菜单权限
            return roleMenuList({ role_id: roleId });
          } else {
            this.$message.error('获取菜单列表失败');
            this.menuList = [];
            this.permissionDialogVisible = true;
            throw new Error('获取菜单列表失败');
          }
        })
        .then(roleMenuResponse => {
          console.log('roleMenuList接口响应:', roleMenuResponse);
          if (roleMenuResponse && roleMenuResponse.code === 200) {
            // 处理角色已有的菜单权限，提取is_checked为1的菜单ID
            const menuData = roleMenuResponse.data || [];
            console.log('原始角色菜单数据:', menuData);

            // 递归提取所有is_checked为1的菜单ID
            const extractCheckedMenuIds = (menus) => {
              let checkedIds = [];
              menus.forEach(menu => {
                if (menu.is_checked === 1) {
                  checkedIds.push(menu.id);
                }
                if (menu.children && menu.children.length > 0) {
                  checkedIds = checkedIds.concat(extractCheckedMenuIds(menu.children));
                }
              });
              return checkedIds;
            };

            this.roleMenus = extractCheckedMenuIds(menuData);
            console.log('提取的选中菜单ID:', this.roleMenus);
          } else {
            this.$message.error('获取角色菜单权限失败');
            this.roleMenus = [];
          }
          this.permissionDialogVisible = true;
        })
        .catch(error => {
          console.error('获取菜单或角色权限失败:', error);
          if (error.message !== '获取菜单列表失败') {
            this.$message.error('获取数据异常，请重试');
          }
          this.permissionDialogVisible = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 转换菜单数据格式
    transformMenuList(menus) {
      return menus.map(menu => {
        const transformedMenu = {
          id: menu.id,
          label: menu.menu_name,
          children: []
        };
        if (menu.children && menu.children.length > 0) {
          transformedMenu.children = this.transformMenuList(menu.children);
        }
        return transformedMenu;
      });
    },
    // 处理权限设置提交
    handlePermissionSubmit(permissionData) {
      console.log('设置权限:', permissionData);

      // 准备roleBindMenu接口需要的参数
      const params = {
        role_id: this.currentPermissionRoleId,
        role_menus: permissionData.checkedKeys
      };

      console.log('调用roleBindMenu接口，参数:', params);

      // 调用roleBindMenu接口
      this.loading = true;
      roleBindMenu(params)
        .then(response => {
          console.log('roleBindMenu接口响应:', response);
          if (response && response.code === 200) {
            this.$message.success('权限设置成功');
            // 权限设置成功后可以选择重新获取角色列表
            // this.fetchRoleList();
          } else {
            this.$message.error('权限设置失败');
          }
        })
        .catch(error => {
          console.error('权限设置失败:', error);
          this.$message.error('权限设置异常，请重试');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 处理删除角色
    handleDelete(row) {
      this.$confirm('确定要删除该角色吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 这里可提交删除数据
        console.log('删除角色:', row);
        this.$message.success('删除成功');
        // 删除成功后重新获取角色列表
        this.fetchRoleList();
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    // 处理搜索
    handleSearch() {
      // 搜索时重置页码
      this.pagination.currentPage = 1;
      this.fetchRoleList();
    },
    // 处理重置
    handleReset() {
      // 重置搜索参数
      this.searchParams = {
        roleName: '',
        roleKey: '',
        status: '',
        createTime: []
      };
      // 重置页码
      this.pagination.currentPage = 1;
      this.fetchRoleList();
    },
    // 处理刷新
    handleRefresh() {
      this.fetchRoleList();
    }
  }
}
</script>

<style scoped>
.role-manage-container {
  padding: 20px;
  background-color: #fff;
  height: 100%;
}

.search-bar {
  margin-bottom: 16px;
  padding: 16px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.search-form {
  display: flex;
  align-items: center;
  gap: 16px;
}

.search-input {
  width: 180px;
}

.search-select {
  width: 120px;
}

.search-btn {
  background-color: #1890ff;
  border-color: #1890ff;
}

.reset-btn {
  border-color: #d9d9d9;
  color: #666;
}

.refresh-btn {
  border-color: #d9d9d9;
  color: #666;
}

.action-bar {
  margin-bottom: 16px;
}

.add-btn {
  background-color: #1890ff;
  border-color: #1890ff;
}

.table-container {
  width: 100%;
}

.status-enabled {
  color: #1890ff;
  font-weight: bold;
}

.status-disabled {
  color: #999;
}

.edit-btn {
  color: #409EFF;
  margin-right: 8px;
}

.delete-btn {
  color: #1890ff;
  margin-right: 8px;
}

.permission-btn {
  color: #67c23a;
}

/* 表格头部样式 */
::v-deep .el-table th {
  background-color: rgb(245, 247, 250) !important;
}
</style>